<template>
  <div>
    <MessageContainer :title="'trash'" :icon="'trash-alt'" />
  </div>
</template>

<script>
import MessageContainer from "@/components/messages/MessageConatiner";

export default {
  name: "trash",
  components: {
    MessageContainer,
  },
};
</script>
